import { Box, Modal, Typography } from '@mui/material';
import { minWidth } from '@mui/system';
import { pxToRem } from 'src/theme/typography';
import ClearIcon from '@mui/icons-material/Clear';

/**
 * ## 기능 설명
 *
 * Custom Modal 창
 *
 */

type CModalFormProps = {
  open: boolean;
  handleClose: () => void;
  title?: string;
  contents: React.ReactElement | null;
  width?: string;
  handleBackdropClick?: () => void;
  hasXButton?: boolean;
};

export default function CModalForm({
  open,
  handleClose,
  title,
  contents,
  width,
  handleBackdropClick = handleClose,
  hasXButton = false,
}: CModalFormProps) {
  return (
    <Modal
      open={open}
      onClose={(e: object, reason: string) => {
        if (reason === 'backdropClick') {
          handleBackdropClick();
        }
      }}
    >
      <Box sx={{ minWidth: width ? width : null, ...style }}>
        {title && (
          <Box
            sx={{
              mb: pxToRem(25),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="Kor_22_b">{title}</Typography>
            {hasXButton && <ClearIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />}
          </Box>
        )}
        {contents}
      </Box>
    </Modal>
  );
}
const style = {
  width: '30%',
  p: pxToRem(30),
  top: '50%',
  left: '50%',
  position: 'absolute' as 'absolute',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: pxToRem(20),
  outline: 'none',
};
